<template>
  <Spinner class="dnl:w-8 dnl:h-8 dnl:text-blue-600 dnl:self-center dnl:mx-auto" />
</template>

<script setup lang="ts">
  import Spinner from '@/components/Spinner.vue';

  defineProps({
    size: {
      type: Number,
      default: 16,
    },
    width: {
      type: Number,
      default: 2,
    },
    color: {
      type: String,
      default: '#fff',
    },
  });
</script>
